module.exports = __webpack_public_path__ + "img/ahorcado2.3d3689ea.jpg";